import { Routes } from '@angular/router';
import { ACCESORIES, CEROKM, FINANCIED } from './onerous-pages.constants';
import { OnerousAccesoriesPageComponent } from './pages/onerous-accesories-page/onerous-accesories-page.component';
import { OnerousFinancedPageComponent } from './pages/onerous-financed-page/onerous-financed-page.component';
import { OnerousInitialPageComponent } from './pages/onerous-initial-page/onerous-initial-page.component';
import { OnerousNewVehiclePageComponent } from './pages/onerous-new-vehicle-page/onerous-new-vehicle-page.component';


export const onerousChildrenRoutes: Routes = [
  { path: FINANCIED, component: OnerousFinancedPageComponent },
  { path: ACCESORIES, component: OnerousAccesoriesPageComponent },
  { path: CEROKM, component: OnerousNewVehiclePageComponent },
  { path: '', component: OnerousInitialPageComponent, pathMatch: 'full' },
]
